<template>
    <div>
        <div class="synorths-div">
            <div>
                <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">Syntenic Gene @ Subgenomes</h2>
            </div>
            <div class="synorths-show">
                <div class="form">
                    <div class="search-gene" style="width: 1100px;margin: 0 auto;">
                        <div style="float: left;width: 330px;">
                            <h2 style="text-align: center;font-size: 22px;color: #407338;">Search across gene ID</h2>
                            <el-form class="demo-form-inline" style="margin-top: 15px" size="small" @submit.native.prevent label-width="80px">
                                <el-form-item label="Gene ID">
                                    <el-input v-model="search_gene" placeholder="Input Gene ID" @keyup.enter.native="tosearch"></el-input>
                                </el-form-item>
                                <el-form-item style="text-align: left" label="flank">
                                    <el-select style="width: 190px;margin-right: 7px"  v-model="flank" placeholder="Select number">
                                        <el-option value="10"></el-option>
                                        <el-option value="20"></el-option>
                                        <el-option value="30"></el-option>
                                        <el-option value="40"></el-option>
                                        <el-option value="50"></el-option>
                                    </el-select>
                                    <a style="font-size: 16px;color: #407338">genes</a>
                                </el-form-item>
                                <el-form-item style="text-align: left">
                                    <el-button style="width: 85px" type="primary" @click="tosearch">Search</el-button>
                                    <el-button style="width: 65px;margin-left: 100px" type="primary" @click="example_help">Help</el-button>
                                </el-form-item>
                                <el-form-item style="text-align: left;" label="example">
                                    <el-button style="width: 110px;font-size: 13px" type="primary" @click="searchAT4G23980"><i>AT4G23980</i></el-button>
                                    <el-button style="width: 110px;font-size: 13px;margin-left: 30px" type="primary" @click="searchBra039913"><i>Bra039913</i></el-button>
                                </el-form-item>
                            </el-form>
                            <div style="margin-top: 10px">
                                <h2 style="text-align: center;font-size: 22px;color: #407338;"><b>Result annotation</b></h2>
                                <a class="result_explain">
                                    <b>1</b>. <b>Block</b>: 24 ancestral genomic blocks.<br/>
                                    <b>2</b>. <b>LF</b>: Least Fractioned subgenome.<br/>
                                    <b>3</b>. <b>MFs</b> (MF1 and MF2): More Fractioned subgenomes.<br/>
                                    <b>4</b>. "<b>•</b>" indicates gene, put mouse on the symbol shows the gene ID. Further click can arise an search navigation for the gene.<br/>
                                    <b>5</b>. "<b>..</b>" indicates tandem array. Further clicks can generate search navigation for these genes.<br/>
                                    <b>6</b>. "<b>MSA</b>" indicates multiple sequence alignment, while "<b>PT</b>" indicates phylogenetic tree. Further clicks can generate corresponding navigation.<br/>
                                    <b>7</b>. Click "BackToMicroSynteny" button below to return to the "MicroSynteny" page if you come from it.
                                </a>
                            </div>
                        </div>
                        <div style="float: left;width: 720px;margin-left: 40px">
                            <el-transfer
                                v-model="checkList"
                                :props="{key:'text', label:'introduction'}"
                                :data="synorths_show"
                                :titles="['To be selected', 'To be shown']"
                                :button-texts="['REMOVE', 'ADD']"
                                @mouseover.native="addTitle"
                                target-order="push"
                            >
                            </el-transfer>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="description">
                <a>Cite synteny analysis </a>
                <a class="Hyperlink" href="https://www.frontiersin.org/articles/10.3389/fpls.2012.00198/full" target="_blank" >
                    "Cheng F, Wu J, Fang L and Wang X (2012).
                    Syntenic gene analysis between <i>Brassica rapa</i> and other <i>Brassicaceae</i> species.
                    Front. Plant Sci. 3:198. doi: 10.3389/fpls.2012.00198".
                </a>
            </div>

            <div class="synorths_result_show" v-if="show_result">
                <hr>
                <br/>
                <div style="float: left; margin-left: 0px"><h2 style="color: #275015">Results</h2></div>
                <div v-if="isToMicro" style="margin-left: 160px" @click="BackToMicroSynteny"><el-button >BackToMicroSynteny</el-button></div>
                <div v-else style="margin-left: 160px"><el-button disabled title="Please click this button when you jump from MicroSynteny!">BackToMicroSynteny</el-button></div>
                <br/>
                <div id="result-show">
                    <table border="1" style="color: #407338; word-break:break-all;" cellspacing="0">
                        <tr>
                            <template v-for="(index, subgenome) in tripling_dict">
                                <td v-if="index===0" :key="index" rowspan="2" style="color: #407357;text-align: center;padding-left: 5px;padding-right: 5px; font-size: 12px">{{subgenome}}</td>
                                <td v-else :key="index" colspan="3" style="color: #407357;text-align: center;padding-left: 5px;padding-right: 5px; font-size: 12px">{{subgenome}}</td>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="information in subgenome_information">
                                <td :key="information" style="color: #407357;text-align: center;padding-left: 5px;padding-right: 5px; font-size: 12px">{{information}}</td>
                            </template>
                        </tr>
                        <tr v-for="(synorths, index) in synorths_sheet" :key="synorths">
                            <template v-if="index == flank">
                                <template v-for="(gene, subgenome) in synorths" >
                                    <td :key="subgenome" style="text-align: center" bgcolor="#98FB98">
                                        <template v-if="subgenome == 'Ath10'">
                                            <a v-if="judge(gene[0])" style="border: 0;color: #397513;">{{gene[0]}}</a>
                                            <a v-else-if="gene[0]!='-' && gene[1].length !=0">
                                                <button style="background: #98FB98;border: 0;color: #397513;width: 60px">
                                                    <a @click="functionSelectionAth10(gene[0], synorths.MSA)" style="font-size: 20px;" :title="gene[0]">•</a>
                                                    <a @click="searchTandem(gene[0])" style="font-size: 10px">••</a>
                                                </button>
                                            </a>
                                            <a v-else-if="gene[0]!='-'">
                                                <button @click="functionSelectionAth10(gene[0], synorths.MSA)" style="background: #98FB98;border: 0;color: #397513;font-size: 20px;width: 60px;">
                                                    <a :title="gene[0]">•</a>
                                                </button></a>
                                            <a v-else style="background: #E8F2EC;border: 0; width: 60px;"></a>
                                        </template>
                                        <template v-else-if="subgenome == 'MSA'">
                                            <a>
                                                <button style="background: #98FB98;border: 0;color: #397513;width: 50px">
                                                    <img src="../assets/img/MSA.png" @click="search_MSA(gene)" style="width: 30px;margin-top: 2px"/>
                                                </button>
                                            </a>
                                        </template>
                                        <template v-else-if="subgenome == 'PT'">
                                            <a>
                                                <button style="background: #98FB98;border: 0;color: #397513;width: 50px">
                                                    <img src="../assets/img/tree2.png" @click="search_PT(gene)" style="width: 25px;margin-top: 2px"/>
                                                </button>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a v-if="judge(gene[0])" style="border: 0;color: #397513; width: 50px">{{gene[0]}}</a>
                                            <a v-else-if="gene[0]!='-' && gene[1].length !=0">
                                                <button style="background: #98FB98;border: 0;color: #397513;width: 60px">
                                                    <a @click="functionSelection(gene[0], synorths.MSA)" style="font-size: 20px;"
                                                       :title="gene[0] + '\nBLASTP e-value: ' + gene[2][0] + '\nleft-support: ' +
                                                               gene[2][1] + '\nright-support: ' + gene[2][2] + '\nstrand: ' + gene[2][3]">•
                                                    </a>
                                                    <a @click="searchTandem(gene[0])" style="font-size: 10px">••</a>
                                                </button>
                                            </a>
                                            <a v-else-if="gene[0]!='-'">
                                                <button @click="functionSelection(gene[0], synorths.MSA)" style="background: #98FB98;border: 0;color: #397513;font-size: 20px;width: 60px;">
                                                    <a :title="gene[0] + '\nBLASTP e-value: ' + gene[2][0] + '\nleft-support: ' +
                                                               gene[2][1] + '\nright-support: ' + gene[2][2] + '\nstrand: ' + gene[2][3]">•</a>
                                                </button></a>
                                            <a v-else style="background: #E8F2EC;border: 0; width: 60px;"></a>
                                        </template>
                                    </td>
                                </template>
                            </template>
                            <template v-else>
                                <template v-for="(gene, subgenome) in synorths">
                                    <td :key="subgenome" style="text-align: center">
                                        <template v-if="subgenome=='Ath10'">
                                            <button v-if="judge(gene[0])" style="background: #E8F2EC;border: 0;color: #397513;font-size: 15px;">{{gene[0]}}</button>
                                            <button v-else-if="gene[0]!='-' && gene[1].length !=0" style="background: #E8F2EC;border: 0;color: #397513;font-size: 20px;width: 60px">
                                                <a @click="functionSelectionAth10(gene[0], synorths.MSA)" :title="gene[0]">•</a>
                                                <a @click="searchTandem(gene[0])" style="font-size: 10px">••</a>
                                            </button>
                                            <button @click="functionSelectionAth10(gene[0], synorths.MSA)" v-else-if="gene[0]!='-'" style="background: #E8F2EC;border: 0;color: #397513;font-size: 20px;width: 60px;">
                                                <a :title="gene[0]">•</a>
                                            </button>
                                            <button v-else style="background: #E8F2EC;border: 0; width: 60px;"> </button>
                                        </template>
                                        <template v-else-if="subgenome == 'MSA'">
                                            <a>
                                                <button style="background: #E8F2EC;border: 0;color: #397513;width: 50px">
                                                    <img src="../assets/img/MSA.png" @click="search_MSA(gene)" style="width: 30px;margin-top: 2px">
                                                </button>
                                            </a>
                                        </template>
                                        <template v-else-if="subgenome == 'PT'">
                                            <a>
                                                <button style="background: #E8F2EC;border: 0;color: #397513;width: 50px">
                                                    <img src="../assets/img/tree2.png" @click="search_PT(gene)" style="width: 25px;margin-top: 2px">
                                                </button>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <button v-if="judge(gene[0])" style="background: #E8F2EC;border: 0;color: #397513;font-size: 15px;width: 50px">{{gene[0]}}</button>
                                            <button v-else-if="gene[0]!='-' && gene[1].length !=0" style="background: #E8F2EC;border: 0;color: #397513;font-size: 20px;width: 60px">
                                                <a @click="functionSelection(gene[0], synorths.MSA)"
                                                   :title="gene[0] + '\nBLASTP e-value: ' + gene[2][0] + '\nleft-support: ' +
                                                               gene[2][1] + '\nright-support: ' + gene[2][2] + '\nstrand: ' + gene[2][3]">•</a>
                                                <a @click="searchTandem(gene[0])" style="font-size: 10px">••</a>
                                            </button>
                                            <button @click="functionSelection(gene[0], synorths.MSA)" v-else-if="gene[0]!='-'" style="background: #E8F2EC;border: 0;color: #397513;font-size: 20px;width: 60px;">
                                                <a :title="gene[0] + '\nBLASTP e-value: ' + gene[2][0] + '\nleft-support: ' +
                                                               gene[2][1] + '\nright-support: ' + gene[2][2] + '\nstrand: ' + gene[2][3]">•</a>
                                            </button>
                                            <button v-else style="background: #E8F2EC;border: 0; width: 60px;"> </button>
                                        </template>
                                    </td>
                                </template>
                            </template>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
        <div id="waiting" v-if="isWaiting">
            <img src="../assets/img/waiting.gif" style="height: 200px;width: 200px">
        </div>
        <ShowTandemArray v-if="show_tandem" :target="selection_gene"
                         @tandemFunctionSelection="ShowTandemBox"
                         @hideBox="hideTandemBox" ></ShowTandemArray>
        <ShowAth10TandemArray v-if="show_Ath10_tandem" :target="selection_gene" 
                              @tandemFunctionSelection="ShowAth10TandemBox" 
                              @hideBox="hideAth10TandemBox"></ShowAth10TandemArray>        
        <SyntenicGeneFunctionSelection v-if="boxtarget" :target="selection_gene"
                                @hideBox="hideSelectionBox"
                                @watchSubFunction="searchSubFunction"></SyntenicGeneFunctionSelection>
        <SyntenicGeneFucntionSelectionBra v-if="Bra_boxtarget" :target="selection_gene"
                                @hideBox="hideBraSelectionBox"
                                @watchSubFunctionBra="searchSubFunction"></SyntenicGeneFucntionSelectionBra>
        <SyntenicGeneFunctionSelectionAth10 v-if="Ath10_boxtarget" :target="selection_gene"
                                @hideBox="hideAth10SelectionBox"
                                @watchSUbFunctionAth10="searchSubFunction"></SyntenicGeneFunctionSelectionAth10>
        <SelectMSA v-if="select_MSA" :target="selection_gene_list"
                   @hideBox="hideSelectMSABox"
                   @watchSubFunction="searchMSASeq"></SelectMSA>
        <SelectPT v-if="select_PT" :target="selection_gene_list"
                   @hideBox="hideSelectPTBox"
                   @watchSubFunction="searchPTSeq"></SelectPT>
        <ShowSubgenomeList v-if="show_subgenome" :target="tempSubgenomeList" 
                            :target1="tempGeneList" 
                            :target2="selection_gene"
                            @hideBox="hideShowSubgenomeList" 
                            @subgenomeFunctionSelection="selectedSubgenomeGene"></ShowSubgenomeList>
        <router-view/>
    </div>
</template>

<script>
    import axios from 'axios';
    import ShowTandemArray from "../components/ShowTandemArray";
    import ShowAth10TandemArray from "../components/ShowAth10TandemArray";
    import SyntenicGeneFunctionSelection from "../components/SyntenicGeneFunctionSelection";
    import SyntenicGeneFucntionSelectionBra from "../components/SyntenicGeneFucntionSelectionBra";
    import SyntenicGeneFunctionSelectionAth10 from "../components/SyntenicGeneFunctionSelectionAth10";
    import SelectMSA from "../components/SelectMSA";
    import SelectPT from "../components/SelectPT";
    import ShowSubgenomeList from "../components/ShowSubgenomeList";
    import {scrollAnimation} from '../assets/js/scrollPos';
    export default {
        name: "Synorths",
        data() {
            return {
                synorths_show: [],
                search_gene: this.$route.query.Gene,
                flank: 10,
                checked: false,
                checkList: ['Ath10', 'Brapa15', 'Brapa30', 'Brapa35', 'BOL20'],
                synorths_sheet: {},
                show_result: 0,
                boxtarget: 0,
                Bra_boxtarget: 0,
                Ath10_boxtarget: 0,
                selection_gene: '',
                selection_subgenome: '',
                selection_gene_list: '',
                tripling_dict: {},
                subgenome_information: [],
                isWaiting: 0,
                isToMicro: 0,
                show_tandem: 0,
                show_Ath10_tandem: 0,
                select_MSA: 0,
                select_PT: 0,
                show_subgenome: 0,
                subgenome_list: [],
                tempSubgenomeList: [],
                tempGeneList: [],
                Aim: this.$route.query.Aim,
            }
        },
        components:{
            ShowTandemArray,
            ShowAth10TandemArray,
            SyntenicGeneFunctionSelection,
            SyntenicGeneFucntionSelectionBra,
            SyntenicGeneFunctionSelectionAth10,
            SelectMSA,
            SelectPT,
            ShowSubgenomeList,
        },
        mounted() {
            this.get_synorths_show();
            this.judge_aim();
            this.judge_micro();
            this.judgeStyle();
            // this.tosearch()
            // this.judge_search_gene()
        },
        methods:{
            judgeStyle() {
                // console.log(document.body.clientHeight)
                // console.log(document.documentElement.clientHeight)
                if (this.show_result == 0) {
                    if (document.documentElement.clientHeight <= document.body.clientHeight) {
                        document.getElementsByTagName('html')[0].style.height = '';
                        document.getElementsByTagName('body')[0].style.height = '';
                    } else {
                        document.getElementsByTagName('html')[0].style.height = '100%';
                        document.getElementsByTagName('body')[0].style.height = '100%';
                    }
                } else {
                    document.getElementsByTagName('html')[0].style.height = '';
                    document.getElementsByTagName('body')[0].style.height = '';
                }
            },
            get_synorths_show(){
                axios({
                    url:'http://39.100.233.196:8001/api/get-synorths-show/',
                    type:'json',
                    method:'get',
                }).then((res)=>{
                    this.synorths_show = res.data
                    // console.log(this.synorths_show)
                })
            },
            addTitle(e) {
                let target_el = e.target;
                if (target_el.title) return;
                target_el.title = target_el.innerText;
            },
            judge_aim() {
                if (typeof this.Aim !== 'undefined') {
                    if (this.Aim == 'return') {
                        if (this.$store.state.search_gene) {
                            this.subgenome_list = this.$store.state.subgenome_list;
                            this.synorths_sheet = this.$store.state.synorths_sheet;
                            this.tripling_dict = this.$store.state.tripling_dict;
                            this.subgenome_information = this.$store.state.subgenome_information;
                            this.show_result = this.$store.state.show_result;
                            this.search_gene = this.$store.state.search_gene;
                            this.checkList = this.$store.state.checkList;
                            const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                            scrollAnimation(currentY, 780)
                        }
                    } else if (this.Aim == 'search') {
                        // console.log(this.search_gene)
                        // this.checkList = this.$store.state.checkList;
                        if (this.search_gene == this.$store.state.search_gene) {
                            this.subgenome_list = this.$store.state.subgenome_list;
                            this.synorths_sheet = this.$store.state.synorths_sheet;
                            this.tripling_dict = this.$store.state.tripling_dict;
                            this.subgenome_information = this.$store.state.subgenome_information;
                            this.show_result = this.$store.state.show_result;
                            this.checkList = this.$store.state.checkList;
                        } else if (this.$store.state.checkList.length != 0) {
                            this.checkList = this.$store.state.checkList;
                            this.tosearch()
                        } else {
                            this.tosearch()
                        }
                    }
                } else if (this.show_result == 1) {
                    // console.log('OKOKOOK1')
                } else if (typeof this.search_gene !== 'undefined') { 
                    this.tosearch()
                }
            },
            judge_micro() {
                if (this.$store.state.gene.length == 0) {
                    this.isToMicro = 0;
                } else {
                    this.isToMicro = 1;
                }
            },
            BackToMicroSynteny () {
                if (this.$store.state.gene.length == 0) {
                    alert('Error! Please click this button when you jump from MicroSynteny!')
                } else {
                    this.$router.push({path: "../RegionMicroSynteny/", query: {Aim: 'return'}})
                }
            },
            // judge_search_gene() {
            //     if (this.show_result == 1) {
            //         // console.log('OKOKOOK1')
            //     } else if (typeof this.search_gene !== 'undefined') {
            //         this.tosearch()
            //     }
            // },
            search_MSA(geneID) {
                // console.log(geneID);
                this.select_MSA = 1;
                this.select_PT = 0;
                this.boxtarget = 0;
                this.show_tandem = 0;
                this.show_Ath10_tandem = 0;
                this.Ath10_boxtarget = 0;
                this.Bra_boxtarget = 0;
                this.show_subgenome = 0;
                this.selection_gene_list = geneID;
            },
            search_PT(geneID) {
                // console.log(geneID);
                this.select_MSA = 0;
                this.select_PT = 1;
                this.boxtarget = 0;
                this.show_tandem = 0;
                this.show_Ath10_tandem = 0;
                this.Ath10_boxtarget = 0;
                this.Bra_boxtarget = 0;
                this.show_subgenome = 0;
                this.selection_gene_list = geneID
            },
            clear_genomes() {
                this.checkList = []
            },
            tosearch() {
                this.show_result = 0;
                this.isWaiting = 1;
                // console.log(this.search_gene);
                var search_gene = this.search_gene;
                var flank = this.flank;
                var checkList = this.checkList;
                var check_str = checkList.join(';');
                // console.log(checkList);
                axios({
                    url:'http://39.100.233.196:8001/api/search-synorths-gene-test/',
                    type:'json',
                    timeout: 30000,
                    params:{
                        search_gene,
                        flank,
                        check_str,
                    },
                    method:'get',
                }).catch(err => {                             // eslint-disable-line no-unused-vars
                    // console.log(err);
                    alert("Please input correct information or check your network!\nIf there is no problem with above, the gene you are looking for doesn't have syntenic gene");
                    this.isWaiting = 0;
                }).then((res)=>{
                    // console.log(res.data)
                    // console.log(res.data[0])
                    var KeyList = res.data[0];
                    var search_subgenome = [];
                    for(var key in KeyList) {
                        search_subgenome.push(key)
                    }

                    this.subgenome_list = search_subgenome.slice(3, search_subgenome.length)
                    // console.log(this.subgenome_list);
                    // var subgenome_list = this.subgenome_list;
                    this.$store.commit('editSubgenomeList', this.subgenome_list);

                    this.synorths_sheet = res.data.slice(0, res.data.length-3);
                    // console.log(this.synorths_sheet);
                    this.$store.commit('editSynorthsSheet', this.synorths_sheet);

                    this.tripling_dict = res.data[res.data.length-1];
                    // this.tripling_dict = {
                    //     'Block': 0,
                    //     'MSA': 0,
                    //     'PT':0,
                    //     'Ath_TAIR_V10.1': 0,
                    //     'Brapa15': 1,
                    //     'Araly_MN47_V1.0': 0,
                    //     'Araly_MN47_V2.1': 0,
                    //     'Brana_Dar_V5_A': 1,
                    //     'Brana_Dar_V5_C': 1,
                    //     'Brana_Dar_V10_C': 1,
                    //     'BnaZS11_A': 1,
                    //     'Boere_V1.0': 0,
                    //     'Boest_V1.2': 0,
                    //     'Braol_JZS_V1.1': 1,
                    // }
                    // console.log(this.tripling_dict);
                    this.$store.commit('editTriplingDict', this.tripling_dict);

                    this.subgenome_information = res.data[res.data.length-2]
                    // console.log(this.subgenome_information);
                    this.$store.commit('editSubgenomeInformation', this.subgenome_information);

                    this.show_result = 1;
                    this.isWaiting = 0;

                    this.$store.commit('editShowResult', this.show_result);
                    this.$store.commit('editSearchGene', this.search_gene);
                    this.$store.commit('editCheckList', this.checkList);
                    // window.localStorage.setItem('subgenome_list', search_subgenome.slice(3, search_subgenome.length))
                    // window.localStorage.setItem('synorths_sheet', res.data.slice(0, res.data.length-3))
                    // window.localStorage.setItem('tripling_dict', res.data[res.data.length-1])
                    // window.localStorage.setItem('subgenome_information', res.data[res.data.length-2])
                    // window.localStorage.setItem('show_result', 1)
                    // window.localStorage.setItem('search_gene', this.search_gene)
                    // console.log(this.show_result)
                    const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                    scrollAnimation(currentY, 880)
                });
            },
            searchAT4G23980() {
                this.search_gene = 'AT4G23980';
                this.tosearch()
            },
            searchBra039913() {
                this.search_gene = 'Bra039913';
                this.tosearch()
            },
            hideSelectMSABox() {
                this.select_MSA = 0
            },
            hideSelectPTBox() {
                this.select_PT = 0
            },
            hideShowSubgenomeList() {
                this.show_subgenome = 0
            },
            searchMSASeq(subfunction, geneList) {
                // console.log(subfunction);
                // console.log(geneList)
                // if (subfunction == 'CDS') {
                //     let routeUrl = this.$router.resolve({
                //         path: "../MSA/",
                //         query: {GeneList: geneList, SearchType: 'CDS'},
                //     });
                //     window.open(routeUrl.href, '_blank');
                // } else if (subfunction == 'Protein') {
                //     let routeUrl = this.$router.resolve({
                //         path: "../MSA/",
                //         query: {GeneList: geneList, SearchType: 'Protein'}
                //     });
                //     window.open(routeUrl.href, '_blank');
                // } else if (subfunction == 'Gene') {
                //     let routeUrl = this.$router.resolve({
                //         path: "../MSA/",
                //         query: {GeneList: geneList, SearchType: 'Gene'}
                //     });
                //     window.open(routeUrl.href, '_blank');
                // }
                let routeUrl = this.$router.resolve({
                    path: '../MSA/',
                    query: {GeneList: geneList, SearchType: subfunction}
                });
                window.open(routeUrl.href, '_blank');
            },
            searchPTSeq(subfunction, geneList) {
                // console.log(subfunction);
                // console.log(geneList)
                // var search_gene_str = geneList;
                // var search_type = subfunction;
                // this.isWaiting = 1;
                // axios({
                //     url: 'http://39.100.233.196:8001/api/search-ETA-seq/',
                //     type: 'json',
                //     params: {
                //         search_gene_str,
                //         search_type
                //     },
                //     method: 'get',
                // }).then((res)=>{
                //     console.log(res.data[0]);
                //     var newick_str = res.data[0];
                //     var seq = res.data[1];
                //     let routeUrl = this.$router.resolve({
                //         path: "../phylogeneticTree/",
                //         query: {Newick: newick_str, Seq: seq},
                //     });
                //     this.isWaiting = 0;
                //     window.open(routeUrl.href, '_blank');
                // });
                let routeUrl = this.$router.resolve({
                    path: '../phylogeneticTree/',
                    query: {GeneList: geneList, SearchType: subfunction}
                });
                window.open(routeUrl.href, '_blank');
            },
            selectedSubgenomeGene(gene) {
                var gene1 = this.selection_gene;
                var gene2 = gene;
                // let routeUrl = this.$router.resolve({
                //     path: "../RegionMicroSynteny/",
                //     query: {Gene1: gene1, Gene2: gene2}
                // });
                // window.open(routeUrl.href, '_blank')
                this.$router.push({path: "../RegionMicroSynteny/", query: {Gene1: gene1, Gene2: gene2}});
            },
            example_help() {
                this.$router.push({path: '../Userguide/'})
            },
            searchTandem(value){
                var regex = "AT[0-9]G";
                // console.log(value);
                if (value.slice(0, 4).match(regex)) {
                    this.show_Ath10_tandem = 1;
                    this.show_tandem = 0;
                    this.boxtarget = 0;
                    this.Ath10_boxtarget = 0;
                    this.Bra_boxtarget = 0;
                    this.select_MSA = 0;
                    this.select_PT = 0;
                    this.show_subgenome = 0;
                    this.selection_gene = value;
                } else {
                    this.show_Ath10_tandem = 0;
                    this.show_tandem = 1;
                    this.boxtarget = 0;
                    this.Ath10_boxtarget = 0;
                    this.Bra_boxtarget = 0;
                    this.select_MSA = 0;
                    this.select_PT = 0;
                    this.show_subgenome = 0;
                    this.selection_gene = value;
                }
            },
            ShowTandemBox() {
                if (this.selection_gene.slice(0, 3) == "Bra") {
                    this.boxtarget = 0;
                    this.Ath10_boxtarget = 0;
                    this.show_tandem = 0;
                    this.Bra_boxtarget = 1;
                } else {
                    this.boxtarget = 1;
                    this.Ath10_boxtarget = 0;
                    this.show_tandem = 0;
                    this.Bra_boxtarget = 0;
                }
            },
            ShowAth10TandemBox() {
                this.boxtarget = 0;
                this.Ath10_boxtarget = 1;
                this.show_Ath10_tandem = 0;
                this.Bra_boxtarget = 0;
            },
            searchGeneSeq (geneID) {
                // console.log(geneID)
                let routeUrl = this.$router.resolve({
                    path: "../GeneSequence/",
                    query: {Gene: geneID}
                });
                window.open(routeUrl.href, '_blank');
            },
            searchGeneInformation () {
                let routeUrl = this.$router.resolve({
                    path: '../SpeciesInfo/'
                });
                window.open(routeUrl.href)
            },
            judge(chara){
                // console.log(chara);
                var patt = /^[ABCDEFGHIJKLMNOPQRSTUVWX]{1,2}$/;
                var answer = patt.test(chara);
                // console.log(answer)
                return answer
            },
            functionSelection(value, subgenome_str){
                // console.log(value);
                // console.log(subgenome_str)
                var list1 = subgenome_str.split(";");
                // console.log(list1);
                var list2 = [];
                var list3 = [];
                for(var key in list1.slice(1, list1.length)) {
                    if(list1[key].length != 0 && list1[key].length != 1) {
                        if(list1[key] != value) {
                            list2.push(this.subgenome_list[key-1])
                            list3.push(list1[key])
                        }
                    }
                }
                // console.log(list2);
                // console.log(list3);
                this.tempSubgenomeList = list2;
                this.tempGeneList = list3;
                if (value.slice(0, 2) == 'AT') {
                    // console.log(value)
                    this.boxtarget = 0;
                    this.Ath10_boxtarget = 1;
                    this.Bra_boxtarget = 0;
                    this.show_tandem = 0;
                    this.show_Ath10_tandem = 0;
                    this.select_MSA = 0;
                    this.select_PT = 0;
                    this.show_subgenome = 0;
                    this.selection_gene = value;
                } else if (value.slice(0, 3) == 'Bra') {
                    this.boxtarget = 0;
                    this.Ath10_boxtarget = 0;
                    this.Bra_boxtarget = 1;
                    this.show_tandem = 0;
                    this.show_Ath10_tandem = 0;
                    this.select_MSA = 0;
                    this.select_PT = 0;
                    this.show_subgenome = 0;
                    this.selection_gene = value;
                } else {
                    this.boxtarget = 1;
                    this.Ath10_boxtarget = 0;
                    this.Bra_boxtarget = 0;
                    this.show_tandem = 0;
                    this.show_Ath10_tandem = 0;
                    this.select_MSA = 0;
                    this.select_PT = 0;
                    this.show_subgenome = 0;
                    this.selection_gene = value;
                }
            },
            functionSelectionAth10(value, subgenome_str){
                // console.log(value);
                var list1 = subgenome_str.split(";");
                // console.log(list1)
                // console.log(this.subgenome_list)
                var list2 = [];
                var list3 = [];
                for(var key in list1.slice(1, list1.length)) {
                    if(list1[key].length != 0 && list1[key].length != 1) {
                        if(list1[key] != value) {
                            list2.push(this.subgenome_list[key-1])
                            list3.push(list1[key])
                            // console.log(list1[key])
                        }
                    }
                }
                // console.log(list2);
                this.tempSubgenomeList = list2;
                this.tempGeneList = list3;
                this.Ath10_boxtarget = 1;
                this.Bra_boxtarget = 0;
                this.show_tandem = 0;
                this.show_Ath10_tandem = 0;
                this.boxtarget = 0;
                this.select_MSA = 0;
                this.select_PT = 0;
                this.show_subgenome = 0;
                this.selection_gene = value;
            },
            searchSubFunction(subfunction, geneID){
                // console.log(subfunction)
                // console.log(geneID)
                this.show_tandem = 0;
                if (subfunction == 'JBrowse') {
                    axios({
                        url: 'http://39.100.233.196:8001/api/search-JBrowse-gene/',
                        type: 'json',
                        params: {
                            geneID
                        },
                        method: 'get',
                    }).then((res)=>{
                        // console.log(res.data[0])
                        var species = res.data[0].species
                        var chromosome = res.data[0].chromosome
                        var startPos = (res.data[0].startPos - 300).toString()
                        var endPos = (res.data[0].endPos + 300).toString()
                        // this.$router.push({path: "../SearchJBrowse/", query:{Genome: species, Chromosome:chromosome, StartPos:startPos, EndPos: endPos}});
                        let routeUrl = this.$router.resolve({
                            path: "../SearchJBrowse/",
                            query:{Genome: species,
                                Chromosome:chromosome,
                                StartPos:startPos,
                                EndPos: endPos}
                        });
                        window.open(routeUrl.href, '_blank');
                    })
                    // 通过../来传参给父视图，然后再刷新到JBrowse去，很强
                }
                else if (subfunction == 'Gene sequence') {
                    // console.log(geneID)
                    let routeUrl = this.$router.resolve({
                        path: "../GeneSequence/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank');
                }
                else if (subfunction == 'Syntenic gene') {
                    this.search_gene = geneID;
                    this.tosearch();
                    this.boxtarget = 0;
                }
                else if (subfunction == 'Flanking region') {
                    let routeUrl = this.$router.resolve({
                        path: "../FlankingRegion/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank');
                }
                else if (subfunction == 'Annotations') {
                    let routeUrl = this.$router.resolve({
                        path: "../Annotations/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank');
                }
                else if (subfunction == 'Nonsyntenic orth') {
                    let routeUrl = this.$router.resolve({
                        path: "../NonSyntenicOrthologs/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
                else if (subfunction == 'Flanking Primer') {
                    let routeUrl = this.$router.resolve({
                        path: "../PrimerDesign/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
                else if (subfunction == 'Polymorph') {
                    let routeUrl = this.$router.resolve({
                        path: "../Polymorph/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
                else if (subfunction == 'BrapaLeafeFP') {
                    let routeUrl = this.$router.resolve({
                        path: "../BrapaLeafeFP/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
                else if (subfunction == 'BrapaLeafCelleFP') {
                    let routeUrl = this.$router.resolve({
                        path: "../BrapaLeafCelleFP/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
                else if (subfunction == 'AthBestHit') {
                    let routeUrl = this.$router.resolve({
                        path: "../AthBestHit/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
                else if (subfunction == 'Coge') {
                    window.open('https://genomevolution.org/CoGe/FeatView.pl?accn=' + geneID, '_blank');
                }
                else if (subfunction == 'TAIR') {
                    window.open('https://www.arabidopsis.org/servlets/TairObject?name=' + geneID + '&type=locus');
                }
                else if (subfunction == 'Expression in At eFP') {
                    window.open('http://bar.utoronto.ca/efp/cgi-bin/efpWeb.cgi?primaryGene=' + geneID)
                }
                else if (subfunction == 'AlphaFold') {
                    window.open('https://alphafold.ebi.ac.uk/search/text/' + geneID)
                }
                else if (subfunction == 'MicroSynteny') {
                    this.show_subgenome = 1;
                    this.boxtarget = 0;
                    this.Ath10_boxtarget = 0;
                    this.Bra_boxtarget = 0;
                }
                else if (subfunction == 'Transcriptome') {
                    let routeUrl = this.$router.resolve({
                        path: "../Transcriptome/",
                        query: {Gene: geneID}
                    });
                    window.open(routeUrl.href, '_blank')
                }
            },
            hideSelectionBox () {
                this.boxtarget = 0;
            },
            hideBraSelectionBox () {
                this.Bra_boxtarget = 0;
            },
            hideAth10SelectionBox () {
                this.Ath10_boxtarget = 0;
            },
            hideTandemBox () {
                this.show_tandem = 0;
            },
            hideAth10TandemBox() {
                this.show_Ath10_tandem = 0;
            },
            checkedAll: function() {
                var _this = this;
                // console.log(_this.checkList);
                // console.log(_this.checked);
                this.$nextTick(function() {
                    // DOM 现在更新了
                    // console.log(_this.checked);
                });
                if (_this.checked) { //实现反选
                    _this.checkList = [];
                } else { //实现全选
                    _this.checkList = [];
                    //这里不能加上item后面的index，否则会报错！！！
                    _this.synorths_show.forEach(function(item) {
                        _this.checkList.push(item.text);
                    });
                }
            },
        },
        watch: { //深度 watcher
            'checkList': {
                //这里不能加上item后面的oldVal，否则会报错！！！
                handler: function(val) {
                    if (val.length === this.synorths_show.length) {
                        this.checked = true;
                    } else {
                        this.checked = false;
                    }
                },
                deep: true
            },
            'show_result': {
                handler() {
                    this.judgeStyle();
                }
            }
        }
    };
</script>

<style>

    .synorths-div {
        overflow:auto;
        background: #E8F2EC;
        width: 1200px;
        margin: 0 auto;
    }

    .synorths-show .form {
        margin: 0 0px;
    }

    .synorths-show .el-form-item__label{
        color: #407338;
    }

    .synorths-show .form #introduce .explain button{
        border: none;
        color: #407338;
        font-weight: bold;
        background-color: #E8F2EC;
        font-family: Microsoft Yahei;
        font-size: 13px;
    }

    .synorths-show .form #introduce button:hover {
        color: black;
    }

    .synorths-show {
        overflow:auto;
        text-align: center;
        /*border: solid 1px #000000;*/
        margin-top: 20px;
        padding-bottom: 50px;
        padding-left: 50px;
        padding-top: 20px;
        padding-right: 50px;
    }

    .synorths-div .description {
        margin: -35px auto 30px 55px;
        width: 1110px;
        color: #407338;
        text-align: left;
        font-size: 15px;
    }

    .synorths-div .description .Hyperlink:hover {
        color: black;
    }

    .synorths-div .description a {
        color: #407338;
    }

    .synorths-div .synorths_result_show {
        margin: -10px 50px 0px 50px;
        width: 1100px;
        /*border: 1px solid #000000;*/
    }

    .synorths-div .synorths_result_show #result-show {
        margin: 0px 0px 30px 0px;
        width: 1100px;
        overflow-x:auto;
        /*border: solid 1px #000000;*/
    }

    #waiting {
        text-align: center;
        position: fixed;
        width: 200px;
        height: 200px;
        /*background: rgba(119, 176, 127, 0.35);*/
        left: 0;
        right: 0;
        top: 35%;
        margin: 0 auto;
    }

    .synorths-show .search-gene .result_explain {
        text-align: left;
        float: left;
        font-size: 13px;
        margin-left: 5px;
        color: #407338;
        font-family: Microsoft Yahei;
    }

    .synorths-show .el-transfer-panel {
        width: 290px;
        text-align: left;
        height: 455px;
    }

    .synorths-show .el-transfer-panel__list{
        padding: 6px 0;
        height:413px;
        overflow: auto;
        list-style: none;
    }

    .synorths-show .el-transfer-panel__item {
        height: 26px;
        line-height: 26px;
    }

    .synorths-show .el-transfer-panel__item.el-checkbox {
        color:#407338;
        font-size: 15px;
    }

    .synorths-show .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
        color:#407338;
        font-size: 16px;
        font-weight: bold;
    }

    .synorths-show .el-transfer__buttons {
        display: inline-block;
        vertical-align: middle;
        padding: 0 10px;
    }

    .synorths-show .el-checkbox__inner {
        z-index: auto;
    }

    .synorths-show .el-form-item--small.el-form-item {
        margin-bottom: 5px;
    }

    .synorths-show .el-form-item--small .el-form-item__content {
        line-height: 30px;
    }

    .synorths-show .el-button--small, .el-button--small.is-round {
        padding: 0px 15px;
    }

    .synorths_result_show .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
        height: 30px;
    }

    .synorths_result_show .el-button:hover {
        color: black;
    }

    .synorths-show .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
        height: 30px;
    }

    .synorths-show .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }

    .synorths-show .el-select-dropdown__item {
        color: #407338;
    }

    .synorths-show .el-input__inner {
        color: #407338;
    }

    .synorths-show .el-form-item__label {
        color: #407338;
        font-size: 16px;
    }
</style>